import { ChatMessage, SendChatMessage, StuenMessage } from "stuen-common";
import { ws } from "./api";
import { useMockApi, userName } from "../state/global";
import { messages } from "../state/chat";
import moment from "moment";
import { currentSong } from "../state/player";
import { soundKeys } from "../components/emotes/emoteKeys";
import { handleEmotes } from "../components/emotes/handleEmotes";

export const handleChatEvents = (socketMessage: StuenMessage) => {
  if (socketMessage instanceof ChatMessage) {
    // If there is a soundKey with the message content, handle that as an emote
    if (soundKeys.includes(socketMessage.message)) {
      handleEmotes(socketMessage.message);
    } else {
      // If not, add the message to the chat
      messages.value = [
        ...messages.value,
        {
          id: crypto.randomUUID(),
          user: socketMessage.name,
          message: socketMessage.message,
          timestamp: moment().format("HH.mm"),
          song: currentSong.value,
        },
      ];
    }
  }
};

export const sendChatMessage = (message: string) => {
  if (useMockApi.value) {
    messages.value = [
      ...messages.value,
      {
        id: crypto.randomUUID(),
        user: userName.value || "Test",
        message: message,
        timestamp: moment().format("HH.mm"),
        song: currentSong.value,
      },
    ];
  } else {
    ws?.send(JSON.stringify(new SendChatMessage(message)));
  }
};
